import { State } from 'interfaces/state'
import { createSelector } from 'reselect'

export const deviceAppStateSelector = (state: State) => state.app.device


export const deviceIdSumSelector = createSelector(
  deviceAppStateSelector,
  (device) => device.deviceIdSum
)
